/* eslint-disable eqeqeq */
import { globalColors } from "../../../../../../_metronic/_assets/sass/custom/globalColors.js";
import DocumentStatusEnum from "../../../../../enums/DocumentStatusEnum";

export function getLabelAndColorFromStatusHelper(status){
    if(status == DocumentStatusEnum.PENDING) {
      return {label: "Pendente", color: globalColors.alertColorLight, textColor: globalColors.textColor2};
    }
    if(status == DocumentStatusEnum.REJECTED) {
      return {label: "Rejeitado", color: globalColors.alertColor2, textColor: globalColors.textColor4};
    }
    if(status == DocumentStatusEnum.VALIDATING) {
      return {label: "Validando", color: globalColors.warningColor, textColor: globalColors.textColor2};
    }
    if(status == DocumentStatusEnum.COMPLETED) {
      return {label: "Completo", color: globalColors.successColor, textColor: globalColors.textColor2};
    }
    return {
      label: "Não informado",
      color: globalColors.secondaryColor3,
      textColor: globalColors.textColor2,
    };
  }
